import React from 'react';
import toast from 'toasted-notes' 
import 'toasted-notes/src/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faTrash, faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';


export function Error(error) {
  let message = '';
  if(typeof error === 'object')
  {
    Object.keys(error).forEach(function(key){
        message += error[key] + '\n';
    });
  }
  else {
        message = error;
  }
  toast.notify(<div style={{color:'#fff',fontSize:15}}><FontAwesomeIcon style={{color:'#fff',fontSize:18,marginRight:10}} icon={faTimesCircle}/> {message}</div>,{position:'top-left',duration:5000});
}

export function Success(message) {
  toast.notify(<div style={{color:'#fff',fontSize:15}}><FontAwesomeIcon style={{color:'#fff',fontSize:18,marginRight:10}} icon={faCheckCircle}/>  {message}</div>,{position:'top-left',duration:5000});
}